import { Outlet } from 'react-router-dom';

import { VinnyChat } from '../components/vinny';
import AuthProvider from '../contexts/AuthProvider';
import useAuth from '../hooks/useAuth';

// Show VinnyChat only when the org licence includes it AND the Super Admin has
// enabled "Vinny Chat" under AI Assistants for the user's role name
// (canUseVinnyChat in AuthProvider combines both).
function AuthenticatedVinnyChat() {
  const { user, userConfig, canUseVinnyChat } = useAuth();
  // Must be authenticated
  if (!user?.isAuthenticated) {
    return null;
  }

  if (!canUseVinnyChat) {
    return null;
  }

  // Pass userId to VinnyChat for user-specific chat isolation
  const currentUserId = String(userConfig?.userId || userConfig?.userid || userConfig?.empId || userConfig?._id || '').trim();
  const userId = currentUserId || null;
  const userEmail = String(userConfig?.emailId || userConfig?.email || '').trim();
  return <VinnyChat userId={userId} userEmail={userEmail} />;
}

export default function GlobalContextLayout() {
  return (
    <AuthProvider>
      <AuthenticatedVinnyChat />
      <Outlet />
    </AuthProvider>
  );
}
